import { MapPin, Search, X } from '@/features/landing/components/icons';

type AppHeaderSearchProps = {
  cityLabel: string;
  query: string;
  searchError?: boolean;
  onQueryChange: (value: string) => void;
  onClear: () => void;
  onSubmit: (event?: { preventDefault?: () => void }) => void;
  onOpenCityModal: () => void;
};

export function AppHeaderSearch({
  cityLabel,
  query,
  searchError = false,
  onQueryChange,
  onClear,
  onSubmit,
  onOpenCityModal,
}: AppHeaderSearchProps) {
  return (
    <form
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit(event);
      }}
      className="hidden min-w-0 flex-1 items-center gap-2 rounded-full border bg-white p-1.5 shadow-[0_10px_30px_rgba(60,40,120,0.05)] md:flex"
      style={{
        borderColor: searchError ? '#DC2626' : '#EAE8F5',
        maxWidth: 480,
        boxShadow: searchError
          ? '0 0 0 3px rgba(220,38,38,0.12)'
          : '0 10px 30px rgba(60,40,120,0.05)',
        transition: 'border-color .15s ease, box-shadow .15s ease',
      }}
    >
      <button
        type="button"
        onClick={onOpenCityModal}
        aria-label="Change city"
        className="inline-flex h-[38px] shrink-0 items-center gap-1.5 rounded-full border-none bg-[#F3F2F9] px-3.5 text-[13px] font-bold text-[#3A3660] transition hover:bg-[#EAE8F5]"
      >
        <span className="text-[#8156B4]"><MapPin size={15} /></span> {cityLabel}
      </button>
      <div
        className="flex min-w-0 flex-1 items-center gap-2 px-2 text-sm text-[#6A6688]"
      >
        <span className="text-[#8156B4]"><Search size={15} /></span>
        <input
          type="search"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search screens..."
          aria-invalid={searchError}
          enterKeyHint="search"
          className="w-full border-none bg-transparent text-[14px] font-medium text-[#3A3660] placeholder-[#6A6688] outline-none"
        />
        {query ? (
          <button
            type="button"
            aria-label="Clear search"
            onClick={onClear}
            className="inline-flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full border-none bg-[#F3F2F9] p-0 text-[#6A6688] hover:text-[#3A3660]"
          >
            <X size={12} />
          </button>
        ) : null}
      </div>
      <button
        type="submit"
        className="dash-btn-gradient inline-flex h-[38px] shrink-0 items-center rounded-full border-none px-5 text-[14px] font-bold text-white transition hover:brightness-105"
      >
        Search
      </button>
    </form>
  );
}
